import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { setTimeOnDate } from 'src/services/dateTime';
import Select, { SelectSkeleton } from 'src/components/form-components/Select/Select';
import { useSubscription } from 'src/hooks';
import { useCallback } from 'react';
import { getServiceArriveTimes } from 'src/services/api/service';
import { IService } from 'src/entities/service';
import { ICalendar, isRandomCalendar } from 'src/entities/calendar';
import { getCalendarArriveTimes } from 'src/services/api/calendar';

interface IArriveTimeProps {
    calendar?: ICalendar;
    service?: IService;
    reservationStart?: string;
    onChange: (selectedTime: string) => void;
    value?: string;
}

const messages = defineMessages({
    arriveTime: {
        id: 'arriveTime',
        defaultMessage: 'Érkezési idő'
    }
});

export const ArriveTime: React.FunctionComponent<IArriveTimeProps> = ({ calendar, service, reservationStart, onChange, value }) => {
    const intl = useIntl();
    const dateString: string = reservationStart || new Date().toISOString();

    const fetchArriveTime = useCallback(async () => {
        if (!service || !reservationStart) {
            return;
        }

        if (calendar && !isRandomCalendar(calendar.Id)) {
            return getCalendarArriveTimes({ calendarId: calendar.Id, serviceId: service.Id, startDate: reservationStart })
        }
        return getServiceArriveTimes({ serviceId: service.Id, startDate: reservationStart })
    }, [reservationStart]);

    const [times, isLoading] = useSubscription(fetchArriveTime);

    const getValidSelectedValue = () => {
        if (!times || !times.length) {
            return;
        }

        const arriveTimeValue =
            value && times.includes(value)
                ? value
                : times[times.length - 1];

        return arriveTimeValue;
    }

    if (isLoading) {
        return (
            <div className="questions__question">
                <h3 className="question__name">
                    <FormattedMessage {...messages.arriveTime} />
                </h3>
                <div className="question__widget">
                    <SelectSkeleton className="select--timepicker" />
                </div>
            </div>
        )
    }

    if (!times || !times.length) {
        return null;
    }

    return (
        <div className="questions__question">
            <h3 className="question__name">
                <FormattedMessage {...messages.arriveTime} />
            </h3>
            <div className="question__widget">
                <Select
                    className="select--timepicker"
                    values={
                        times.map((time) => {
                            return {
                                value: time,
                                label: intl.formatTime(setTimeOnDate(dateString, time))
                            }
                        })}
                    value={getValidSelectedValue()}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}